import CheckSearch from 'components/Search/CheckSearch'

import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: CheckSearch,
  name: 'DDICheckSearch'
})
